<app-block-ui>
  <!-- Login Wrapper -->
  <ng-container *ngIf="isLogin; else nonLoginTemplate">
    <!-- Notification Banner -->
    <div class="notification-banner" *ngIf="verbiage.loginPageWebsiteAnnouncement && !isBannerClosed">
      <div class="notification-content">
        <span class="notification-text">
          {{ verbiage.loginPageWebsiteAnnouncement }}
        </span>
        <button class="notification-close" (click)="closeBanner()">
          <i class="material-icons">close</i>
        </button>
      </div>
    </div>
    <div class="login-wrapper">
      <router-outlet (activate)="onRouterChange($event)"></router-outlet>
    </div>
    <app-login-footer></app-login-footer>
  </ng-container>

  <ng-template #nonLoginTemplate>
    <div class="wrapper" id="wrapper" appScreenBehavior>
      <ng-container *ngTemplateOutlet="showDefaultHeader ? defaultHeader : customHeader"></ng-container>
      <router-outlet (activate)="onRouterChange($event)"></router-outlet>
    </div>
    <app-footer></app-footer>
  </ng-template>

  <ng-template #defaultHeader>
    <app-header [notifyList]="alertNotifyList"></app-header>
  </ng-template>

  <ng-template #customHeader>
    <app-custom-header></app-custom-header>
  </ng-template>
</app-block-ui>